module.exports = __webpack_public_path__ + "img/word.09ee3caa.png";